export default __webpack_public_path__ + "static/media/akudui-OhMfc8ADMd0-unsplash.a5c9fe5f.jpg";